<template>
  <v-timeline
    dense
    clipped
  >
    <v-timeline-item
      fill-dot
      large
    >
      <span slot="icon">
        <v-icon color="white">notifications</v-icon>
      </span>

      <h1 class="headline">
        News Feed

        <help-tooltip>
          Latest facts happened in the {{ organization ? 'organization' : 'project' }}
        </help-tooltip>
      </h1>
    </v-timeline-item>

    <v-timeline-item
      v-for="event in feed"
      :key="event.id"
      color="primary"
    >
      <template v-slot:icon>
        <pa-user-avatar
          :user-id="event.who.id"
          :size="38"
          type="avatar"
        />
      </template>

      <div class="feed-event">
        <span class="feed-event__who">{{ event.who.profile ? event.who.profile.displayName : event.who.email }}</span>
        {{ buildActionVerb(event) }} {{ event.name }}
        <span v-if="organization && event.project">in
          <router-link :to="{ name: 'project-details', params: { name: event.project } }">
            {{ event.project }}
          </router-link>
        </span>
      </div>
      <div class="text-right caption grey--text mt-2">
        {{ event.when | fmtFromNow }}
      </div>
    </v-timeline-item>

    <v-timeline-item
      v-if="!feed.length"
      small
      hide-dot
    >
      <div class="grey--text text-center">
        When something happens in this {{ organization ? 'organization' : 'project' }},
        it will be reported here.
      </div>
    </v-timeline-item>
  </v-timeline>
</template>

<script>
import { mapGetters } from 'vuex'

import { db } from '@/plugins/stitch'

const EVENT_DICT = {
  attachment: {
    created: 'uploaded a new document',
    updated: 'edited document'
  },
  comment: {
    created: 'commented',
    updated: 'edited a comment'
  }
}

export default {
  props: {
    organization: {
      type: Boolean,
      default: false
    },
    project: {
      type: Object,
      default: () => { return {} }
    }
  },
  data () {
    return {
      projectId: this.$route.params.name,
      feed: []
    }
  },
  computed: {
    ...mapGetters([ 'getUserById' ])
  },
  mounted () {
    this.loadData()
  },
  methods: {
    loadData () {
      const where = this.organization
        ? { organization: this.$currentOrganization.id }
        : { project: this.projectId }

      db
        .collection('feed')
        .find(where, {
          sort: { when: -1 },
          limit: 25
        })
        .toArray()
        .then(querySnapshot => {
          this.feed = []

          querySnapshot.forEach(event => {
            let data = event.data()
            data.id = event.id
            data.who = this.getUserById(data.who)
            this.feed.push(data)
          })
        })
    },
    buildActionVerb ({ action, entity, name }) {
      if (EVENT_DICT[entity] && EVENT_DICT[entity][action]) {
        return EVENT_DICT[entity][action]
      } else {
        return `${action} ${entity}`
      }
    }
  },
  beforeRouteUpdate (to, from, next) {
    next()
    this.loadData()
  }
}
</script>

<style lang="scss">
.feed-event {
  &__who {
    font-weight: bold;
  }
}
</style>
